module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10261.0a35c6f4.jpg";